// extracted by mini-css-extract-plugin
export default {"cardDark":"Card_cardDark__BwqKt","card":"Card_card__YiVWA","favButton":"Card_favButton__FbL5h","CardBody":"Card_CardBody__1pnZs","title":"Card_title__bqXuA"};